import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

import Clickable from '@prisjakt/ui-clickable';
import { CardContent } from '@prisjakt/ui/card';
import { TitleMediumText } from '@prisjakt/ui/text/variants';
import RatingComponent from '../rating';

export const Header = styled.div`
  display: flex;
  width: 100%;
`;

export const Footer = styled(CardContent)`
  && {
    justify-content: flex-end;
    flex: 0 1 auto;
    border-top: 1px solid ${p => p.theme.lines.primary};
    width: 100%;
    padding-top: ${layout.measurements.spacingNormal};
  }
`;

export const Title = styled(TitleMediumText)``;

export const Content = styled(CardContent)`
  & > :not(:last-child) {
    margin-bottom: unset;
  }

  ${Header} {
    margin-bottom: ${layout.measurements.spacingTiny};
  }

  ${Title} {
    margin-bottom: ${layout.measurements.spacingNormal};
  }
`;

export const MediaLink = styled(Clickable)`
  display: block;
  width: 100%;
  height: 100%;
`;

export const Rating = styled(RatingComponent)`
  position: absolute;
  top: ${layout.measurements.spacingNormal};
  left: ${layout.measurements.spacingNormal};
`;
